import axios from "axios";
import {
    REVIEW_LIST_REQUEST,
    REVIEW_LIST_SUCCESS,
    REVIEW_LIST_FAIL,
    REVIEW_DETAILS_REQUEST,
    REVIEW_DETAILS_SUCCESS,
    REVIEW_DETAILS_FAIL
} from "../constants/categoryConstants";
import { BASE_URL, REVIEW_URL } from "../api";


export const listReview = () => async (dispatch) => {
  try {
    dispatch({ type: REVIEW_LIST_REQUEST });
    const { data } = await axios.get(BASE_URL+REVIEW_URL);
    dispatch({
      type: REVIEW_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: REVIEW_LIST_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};



export const listReviewDetails =(id) => async (dispatch)=>{

  try{
      dispatch({type:REVIEW_DETAILS_REQUEST})
      const {data} = await axios.get(`/api/products/${id}`)

      dispatch({
          type:REVIEW_DETAILS_SUCCESS,
          payload:data
      })

  }
  catch(error){
      dispatch({
          type:REVIEW_DETAILS_FAIL,
          payload:error.response && error.response.data.detail
          ? error.response.data.detail
          :error.message,
      })

  }
}